(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-feature"] && !Shopify.designMode) return;
  try {
    
  const initializeStoryFeatureReveals = (root = document) => {
    const sections = root.querySelectorAll('.story-feature:not(.story-feature--reveal-ready)');

    if (!sections.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      sections.forEach((section) => section.classList.add('story-feature--revealed'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('story-feature--revealed');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach((section) => {
      section.classList.add('story-feature--reveal-ready');
      observer.observe(section);
    });
  };

  initializeStoryFeatureReveals();
  document.addEventListener('shopify:section:load', (event) => initializeStoryFeatureReveals(event.target));

  } catch(e) { console.error(e); }
})();
})();
